import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    form: {
        width: '100%',
    },
}));

export default useStyles;
